<template>
  <div>
    <HeroBanner :page="'guild'"/>
    <div class="container">
    </div>
  </div>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
export default {
  components: {
    HeroBanner
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageGuild.vue